module.exports = __webpack_public_path__ + "static/media/game.abb73ae4.svg";